module.exports = __webpack_public_path__ + "img/logo-navy-full.e5539c3.png";